export const mortgagePaymentsRecalculation= {
    heading: 'mortgage-Payments-Recalculation-heading',
    paragraph1: 'mortgage-Payments-Recalculation-paragraph1',
    yearlyExplained: 'mortgage-Payments-Recalculation-yearlyExplained',
    usefulGuide: 'mortgage-Payments-Recalculation-usefulGuide',
    keepOnTrack: 'mortgage-Payments-Recalculation-keepOnTrack',
    youCanWatch: 'mortgage-Payments-Recalculation-youCanWatch',
    ifYouPrefer: 'mortgage-Payments-Recalculation-ifYouPrefer',
    thingsToKnow: 'mortgage-Payments-Recalculation-thingsToKnow',
    continuePreviousPayments:'mortgage-Payments-Recalculation-continuePreviousPayments',
    missedPayment: 'mortgage-Payments-Recalculation-missedPayment',
    reduceMortgage: 'mortgage-Payments-Recalculation-reduceMortgage',
    frequentQuestions: 'mortgage-Payments-Recalculation-frequentQuestions',
    backButton: 'mortgage-Payments-Recalculation-backButton', 
    youtubeIframe: 'mortgage-Payments-Recalculation-youtube-iframe'
};